import React from 'react';
import '../../../App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTruck } from '@fortawesome/free-solid-svg-icons'
import { faSoap } from '@fortawesome/free-solid-svg-icons'
import { faLiraSign } from '@fortawesome/free-solid-svg-icons'
import { faLeaf } from '@fortawesome/free-solid-svg-icons'
import { faMedal } from '@fortawesome/free-solid-svg-icons'
import { faMoneyBillAlt } from '@fortawesome/free-solid-svg-icons'
import { experimentalStyled as styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Col, Container, Row, CardHeader, CardBody, CardTitle, CardText } from 'reactstrap';

const service = [
    {
        src: <i class="fas fa-globe-asia"></i>,
        name: 'Native Language Teaching',
        title: 'Courses taught in both English & your native language.',
        dataAos: "fade-right"
    },
    {
        src: <i class="fas fa-headset"></i>,
        name: 'Support',
        title: 'Full-time support from expert teachers in your native language.',
        dataAos: "fade-up"
    },
    {
        src: <i class="far fa-file-alt"></i>,
        name: 'HSKK Practice',
        title: 'Special speaking and writing practice with mock tests.',
        dataAos: "fade-up"
    },
    {
        src: <i class="fas fa-users"></i>,
        name: 'Community',
        title: 'Friendly community to get engaged with.',
        dataAos: "fade-left"
    }
];

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const ChooseUs = () => {
    return (

        <Container >
            <Box sx={{ flexGrow: 1 }} id="ChooseUs">
                <Typography variant="h1" className="heading" style={{ pb: 0, fontWeight: "700" }} data-aos="zoom-out-up" data-aos-duration="1000" data-aos-easing="ease-in-sine"
                    gutterBottom>

                    <span>W</span>
                    <span>H</span>
                    <span>Y</span>
                    <span className="space">{""}</span>
                    <span>L</span>
                    <span>A</span>
                    <span>N</span>
                    <span>G</span>
                    <span>U</span>
                    <span>A </span>
                    <span>E</span>
                    <span className="space">{""}</span>
                    <span>B </span>
                    <span>U </span>
                    <span>D</span>
                    <span>D</span>
                    <span>Y</span>

                </Typography>
                <Row>
                    {service.map(item =>
                        <Col md={3} className="d-flex justify-content-center" key={item.name}>
                            <Card style={{ width: '20rem', textAlign: "center" }} data-aos={item.dataAos} data-aos-easing="linear"
                                data-aos-duration="1500">
                                <CardHeader className="text-center mt-2 text-danger"><span className="icon-size">
                                    {item.src}
                                </span></CardHeader>
                                <CardBody>
                                    <CardTitle tag="h4" >{item.name}</CardTitle>
                                    <CardText className="text-secondary">{item.title}</CardText>
                                </CardBody>
                            </Card>
                        </Col>
                    )}
                </Row>
            </Box>
        </Container>

    );
};

export default ChooseUs;